import { CopyMetadataFromParent, Property } from '@skylab-shared/core';
import { VatSummary } from '../document/vat-summary';
import { InventoryDocumentKind } from './inventory-document-kind';
import { InventoryGoodsReceiptDocumentModel } from './inventory-goods-receipt-document.model';

@CopyMetadataFromParent()
export class InventoryGoodsReceiptAdjustmentDocumentModel extends InventoryGoodsReceiptDocumentModel {
    @Property()
    public adjustedDocumentId: number;

    @Property()
    public adjustedDocumentVersion: string;

    @Property()
    public override readonly kind: InventoryDocumentKind = InventoryDocumentKind.GoodsReceiptAdjustment;

    public vatSummary: VatSummary;
}
